module.exports = __webpack_public_path__ + "img/loader2.039fd53d.gif";